import {
  IonCard,
  IonCardContent,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonTextarea,
} from '@ionic/react';
import { checkmark, close } from 'ionicons/icons';
import './styles.scss';
import { TextFieldTypes } from '@ionic/core';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { IoEye, IoEyeOff } from 'react-icons/io5';

export interface InputCardTypes {
  onFocusOff?: (event: CustomEvent<FocusEvent>) => void;
  onFocus?: (event: CustomEvent<FocusEvent>) => void;
  onBlur?: (event: CustomEvent<any>) => void;
  type: TextFieldTypes;
  placeholder: string;
  formValues?: any;
  name: string;
  borders?: boolean;
  label?: boolean;
  icon?: Element | ReactElement | 'string';
  iconSlot?: 'start' | 'end';
  passwordToggle?: boolean;
  disabled?: boolean;
  mode?: 'ios' | 'md';
  maxLength?: number | 256;
  minLength?: number | 1;
  clear?: boolean;
  inputType: 'text-field' | 'text-box';
  required?: boolean;
  value: (arg0: (form: any) => any) => any;
  enterEvent?: (event: KeyboardEvent, value: string) => void;
  color?: string;
  background?: string;
  customStyles?: { card?: string };
}

const InputCard = ({
  onFocusOff,
  onFocus,
  borders,
  onBlur,
  color,
  background,
  type,
  placeholder,
  name,
  icon,
  iconSlot = 'start',
  mode,
  maxLength,
  minLength,
  clear,
  inputType,
  required,
  formValues,
  value,
  enterEvent,
  disabled,
  passwordToggle,
  customStyles,
}: InputCardTypes) => {
  const [isNumberInput, setIsNumberInput] = useState<boolean>(false);
  const [_value, setValue] = useState<string>('');
  const optionalProps: { value?: string | number } = {};
  const [passwordVisible, setPasswordVisible] = useState(false);
  const fieldRef = useRef<any>(null);

  useEffect(() => {
    if (type === 'number') {
      setIsNumberInput(true);
    }
  }, []);
  if (formValues) {
    optionalProps.value = formValues?.[name];
  }
  const dispatchEnterAction = (e: any) => {
    if ((e as KeyboardEvent).key === 'Enter' && enterEvent) {
      enterEvent(e as KeyboardEvent, _value);
    }
  };

  const onInputChange = (e: string) => {
    let val = e;
    if (isNumberInput) {
      if (/[^0-9.,]/.test(val)) {
        val = val ? val!.slice(0, -1) : val;
      }
      const formated = val
        ? val
            .toString()
            .replace(/,/g, '')
            .replace(/(?<=\d)(?=(\d{3})+(?!\d))/g, ',')
        : val;
      val = formated;
    }
    setValue(val);
    value((form: any) => {
      if (Object.prototype.toString.call(form) === '[object Object]') {
        return {
          ...form,
          [name]: val,
        };
      }
      if (Array.isArray(form)) {
        return [...form, val];
      }
    });
  };
  const onTextBoxChange = (e: string) => {
    value((form: any) => {
      if (Object.prototype.toString.call(form) === '[object Object]') {
        return {
          ...form,
          [name]: e,
        };
      }
      if (Array.isArray(form)) {
        return [...form, e];
      }
    });
  };
  return (
    <IonCard
      className={
        'inputCard  size-full overflow-hidden ' + customStyles?.card ||
        ' bg-white'
      }
      mode={mode}
      style={{
        border: borders ? '1px solid rgba(15, 50, 77, 0.5)' : 'none',
        borderOpacity: '0.6',
      }}
    >
      <IonCardContent className={'size-full bg-transparent'}>
        <IonItem
          lines="none"
          className={
            'size-full p-0 flex flex-row items-center justify-center relative'
          }
          style={{
            '--background': 'transparent',
            '--color': color ? color : 'var(--ion-color-primary)',
          }}
        >
          {inputType === 'text-box' ? (
            <IonTextarea
              {...(optionalProps as { value: string | null | any })}
              onIonFocus={onFocus}
              onKeyDown={dispatchEnterAction}
              required={required}
              ref={fieldRef}
              placeholder={placeholder}
              name={name}
              style={{
                '--background': 'transparent',
                '--color': color ? color : 'var(--ion-color-primary)',
                caretColor: color ? color : 'var(--ion-color-primary)',
              }}
              onIonBlur={onFocusOff}
              minlength={minLength}
              maxlength={maxLength}
              onIonChange={(e) => onTextBoxChange(e.detail!?.value!)}
            ></IonTextarea>
          ) : (
            <IonInput
              {...optionalProps}
              onIonFocus={onFocus}
              required={required}
              onKeyDown={dispatchEnterAction}
              ref={fieldRef}
              type={
                isNumberInput || (type === 'password' && passwordVisible)
                  ? 'text'
                  : type
              }
              className="!focus:border-b-2 "
              placeholder={placeholder}
              name={name}
              pattern={'string'}
              style={{
                '--background': 'transparent',
                '--color': color ? color : 'var(--ion-color-primary)',
                caretColor: color ? color : 'var(--ion-color-primary)',
              }}
              clearInput={clear}
              onIonBlur={onBlur}
              minlength={minLength}
              maxlength={maxLength}
              onIonChange={(e) => onInputChange(e.detail!?.value!)}
            ></IonInput>
          )}

          {icon && (
            <IonLabel
              slot={iconSlot}
              className="flex items-center justify-center mx-2"
            >
              {icon}
            </IonLabel>
          )}
          {passwordToggle && (
            <div
              className="h-[30px] w-auto aspect-square text-primary "
              onClick={() => {
                setPasswordVisible(!passwordVisible);
              }}
            >
              {passwordVisible ? (
                <IoEye size="100%" />
              ) : (
                <IoEyeOff size="100%" />
              )}
            </div>
          )}
        </IonItem>
      </IonCardContent>
    </IonCard>
  );
};

export default InputCard;
